import {
  ROUTES,
  TABLE_FILTER_KEYS,
  USER_ROLES,
} from '../../../../common/constants';

export const LIBRARY_STAFF_BASE_PATH = `${ROUTES?.SYSTEM_USERS}${ROUTES?.LIBRARY_STAFF}`;
export const LIBRARY_STAFF_TABLE_FILTER_KEY =
  TABLE_FILTER_KEYS?.SYSTEM_USERS_LIBRARY_STAFF;

export const STAFF_ROLES = [
  USER_ROLES?.LIBRARIAN,
  USER_ROLES?.PICKER,
  USER_ROLES?.PACKER,
].map((role) => ({ label: role?.label, value: role?.key }));

export const STAFF_ROLE_KEYS = STAFF_ROLES.map((role) => role?.value);

export const ALL_STAFF_ROLES = 'ALL';
export const STAFF_ROLE_FILTER_OPTIONS = [
  { label: 'All', value: ALL_STAFF_ROLES },
  ...STAFF_ROLES,
];

export const getStaffRole = (roles = []) =>
  STAFF_ROLE_KEYS.find((role) => roles?.includes(role));

export const getStaffRoleLabel = (role) =>
  STAFF_ROLES.find((item) => item?.value === role)?.label || '-';

export const LIBRARY_ALREADY_HAS_LIBRARIAN = 'LIBRARY_ALREADY_HAS_LIBRARIAN';

export const formatLibrary = (library) =>
  library ? `${library?.name} (${library?.libraryNumber})` : '-';
